/* eslint-disable no-undef */
import $ from 'jquery'
import queryString from 'query-string';
import 'daterangepicker'
import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
dayjs.extend(customParseFormat)

class Daterange {

  constructor() {
    this.date = document.querySelector('input[name="daterange"]');

    if (this.date) {
      //this.activateCkb = document.querySelector('#input-activate');
      this.defaultDates = document.querySelector('#default-dates')
      this.dateRangeElt = document.querySelector('input[name="daterange"]');
      this.initEvents();
      this.initDaterangePicker();
    }
  }

  initDaterangePicker() {
    let start, end;
    //this.activateCkb.checked = true;
    const {query} = queryString.parseUrl(window.location.href)
    if (query.start && query.end) {
      start = dayjs(query.start, 'DD/MM/YYYY').toDate();
      end = dayjs(query.end, 'DD/MM/YYYY').toDate();
    } else {
      start = new Date();
      end = dayjs().add(1, 'year').toDate();
    }


    $('input[name="daterange"]').daterangepicker({
      'startDate': start,
      'endDate': end,
      'locale': {
        'format': 'DD/MM/YYYY',
        'applyLabel': 'Valider',
        'cancelLabel': 'Annuler',
        'fromLabel': 'De',
        'toLabel': 'A',
        'customRangeLabel': 'Custom',
        'daysOfWeek': ['Di', 'Lu', 'Ma', 'Me', 'Je', 'Ve', 'Sa'],
        'monthNames': ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
        'firstDay': 1,
      },
    }, (start, end) => {
      //this.dateRangeElt.value = `${start.format('DD/MM/YYYY')} - ${end.format('DD/MM/YYYY')}`
      $('input[name="start"]').val(start.format('DD/MM/YYYY'));
      $('input[name="end"]').val(end.format('DD/MM/YYYY'));
      document.querySelector('.filter-form').submit();
    });
  }

  initEvents() {
    this.defaultDates.addEventListener('click', (e) => {
      e.preventDefault();
      const start = dayjs();
      const end = dayjs().add(1, 'year');
      const query = {
        'start': start.format('DD/MM/YYYY'),
        'end': end.format('DD/MM/YYYY'),
      }
      window.location.href = `?${queryString.stringify(query)}`
    });
  }

  setDisabled() {
    this.dateRangeElt.removeAttribute('disabled');
    if (!this.activateCkb.checked) {
      this.dateRangeElt.setAttribute('disabled', 'disabled');
    }
  }

}

export default new Daterange()



// WEBPACK FOOTER //
// ./scripts/components/daterange.js